module.exports = __webpack_public_path__ + "img/gubeishuizhen.66053a36.png";